import mqtt from "mqtt";

export const client = mqtt.connect(
  `mqtt://${process.env.REACT_APP_BROKER_URI}`,
  {
    username: process.env.REACT_APP_MQTT_CLIENT,
    password: process.env.REACT_APP_MQTT_PASSWORD,
  }
);

client.on("connect", () => {
  // console.log("mqtt connection established");
});

client.on("error", (err) => {
  console.log(err.message);
});
